exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\r\n* Auto-generated\r\n* Do not edit!!!\r\n*/\r\n\r\n.k-input,\r\n.k-textbox,\r\n.k-numerictextbox,\r\n.k-maskedtextbox,\r\n.k-datepicker,\r\n.k-timepicker,\r\n.k-slider-horizontal {\r\n    width: 100%;\r\n}\r\n\r\nkb-date-time-picker>span {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n}\r\n\r\nkb-date-time-picker .k-datepicker,\r\nkb-date-time-picker .k-timepicker {\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1;\r\n            flex: 1;\r\n}\r\n\r\ntextarea[rows] {\r\n    height: auto;\r\n}\r\n\r\nkb-image img {\r\n    max-width: 100%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/kendo.overrides.css
// module id = ../../../../../src/app/kendo.overrides.css
// module chunks = main